import {
  EmailFlowLog,
  EmailFlowLogsSearchRequest,
  EmailLogReportsResponse,
} from "@dashboard-v3/api";

export type Filters = {
  sender: string;
  recipient: string;
  subject: string;
  messageId: string;
  fromDate: string;
  fromTime: string;
  toDate: string;
  toTime: string;
  hasAttachments: boolean;
  errorCodes: Array<
    | "STORAGE_SHARE_FILE_ERROR"
    | "STORAGE_COLLABORATE_ERROR"
    | "STORAGE_ERROR_STORING_FILE"
    | "STORAGE_SET_MXHERO_METADATA_ERROR"
    | "STORAGE_ERROR_SET_METADATA"
    | "ASYNC_STORAGE_INSTANCE_FOR_USER"
    | "STORAGE_ATTACHMENT_EXTRACT_ERROR"
    | "STORAGE_MAIL_EXTRACT_ERROR"
  >;
  status:
    | "DROPPED"
    | "REJECTED"
    | "BOUNCED_EXTERNAL"
    | "BOUNCED_INTERNAL"
    | "DELIVERED"
    | "WITH_RETRIES"
    | "TIMED_OUT"
    | "QUARANTINE"
    | "WITH_RULE_ERRORS"
    | "WITH_STORAGE_ERRORS"
    | "WITH_ERRORS"
    | "";
};

export const DELIVERY_STATUS_CUTOFF = "2026-05-26";

export type Tab = "SEARCH" | "REPORTS";
export type State = {
  status:
    | "IDLE"
    | "SEARCHING"
    | "GETTING_MORE_LOGS"
    | "GENERATING_REPORT"
    | "FETCHING_REPORTS";
  searchCriteria: EmailFlowLogsSearchRequest;
  logs: EmailFlowLog[];
  hasMore: boolean;
  page: number;
  rowsPerPage: number;
  filtersExpanded: boolean;
  currentTab: Tab;
  reportsData: EmailLogReportsResponse;
  showReportConfig: boolean;
  selectedEmail: EmailFlowLog;
};
